// extracted by mini-css-extract-plugin
export default {"control":"Product_control__lBl6H","richText":"Product_richText__qGfMl"};